import React, { useContext } from 'react';
import Accordion from '../Accordion/Accordion';
import Button from '../Button';
import { TrackingContext } from '../StreamField/StreamField';
import { trackCtaClickStartpage } from '../../utils/datalayer';
import styles from './CampaignDirectionBlock.module.scss';
import PropTypes from 'prop-types';

const CampaignDirectionBlock = ({
    title,
    text,
    link,
    content,
    contactBox = {},
}) => {
    const bannerLevel = useContext(TrackingContext) !== null;
    return (
        <div className={styles['CampaignDirectionBlock']}>
            <div className={styles['CampaignDirectionBlock__Container']}>
                <div
                    className={styles['CampaignDirectionBlock__TextContainer']}>
                    <h2 className={styles['CampaignDirectionBlock__Header']}>
                        {title}
                    </h2>
                    <p className={styles['CampaignDirectionBlock__Text']}>
                        {text}
                    </p>
                    {link.href && link.label && (
                        <div
                            className={
                                styles['CampaignDirectionBlock__LinkContainer']
                            }>
                            <Button
                                href={link.href}
                                text={link.label}
                                type="tertiary"
                                icon="arrow"
                                iconSize="large"
                                iconColor="pink"
                                buttonColor="pink"
                                onClick={() => {
                                    if (bannerLevel) {
                                        trackCtaClickStartpage(bannerLevel);
                                    }
                                }}
                            />
                        </div>
                    )}
                    {(!!contactBox.contact || !!contactBox.richText) && (
                        <div
                            className={
                                styles[
                                    'CampaignDirectionBlock__ContactContainer'
                                ]
                            }>
                            {!!contactBox.contact && (
                                <p
                                    className={
                                        styles[
                                            'CampaignDirectionBlock__Contact'
                                        ]
                                    }>
                                    {contactBox.contact}
                                </p>
                            )}
                            {!!contactBox.richText && (
                                <div
                                    className={
                                        styles[
                                            'CampaignDirectionBlock__ContactText'
                                        ]
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: contactBox.richText,
                                    }}></div>
                            )}
                        </div>
                    )}
                </div>
                <div
                    className={
                        styles['CampaignDirectionBlock__AccordionContainer']
                    }>
                    {content.map((item, index) => (
                        <Accordion key={index} {...item} />
                    ))}
                </div>
            </div>
        </div>
    );
};

CampaignDirectionBlock.propTypes = {
    contactBox: PropTypes.object,
};

export default CampaignDirectionBlock;
